import SearchSuggester from '../SearchSuggester.vue.js';
import { internalComponentDefinition } from '../../../helpers/component.js';
import { mergeConfiguration } from '../../../helpers/factory.js';

const DEFAULT_COMPONENT_NAME = "fds-search-suggester";
const defaultSearchSuggesterConfiguration = {
  options: {
    componentName: DEFAULT_COMPONENT_NAME
  }
};
const searchSuggesterFactory = (configuration) => {
  var _a, _b, _c, _d;
  const componentName = (_d = (_c = (_a = configuration.options) == null ? void 0 : _a.componentName) != null ? _c : (_b = defaultSearchSuggesterConfiguration.options) == null ? void 0 : _b.componentName) != null ? _d : DEFAULT_COMPONENT_NAME;
  const mergedConfiguration = mergeConfiguration(configuration, defaultSearchSuggesterConfiguration);
  return internalComponentDefinition(componentName, mergedConfiguration, SearchSuggester);
};
const searchSuggesterPlugin = {
  install(Vue, configuration = defaultSearchSuggesterConfiguration) {
    var _a, _b, _c, _d;
    const componentName = (_d = (_c = (_a = configuration.options) == null ? void 0 : _a.componentName) != null ? _c : (_b = defaultSearchSuggesterConfiguration.options) == null ? void 0 : _b.componentName) != null ? _d : DEFAULT_COMPONENT_NAME;
    Vue.component(componentName, searchSuggesterFactory(configuration));
  }
};

export { defaultSearchSuggesterConfiguration, searchSuggesterFactory, searchSuggesterPlugin };
